import script from "./ProfilePasswordCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePasswordCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePasswordCard.vue?vue&type=style&index=0&id=39fe1492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fe1492"]])

export default __exports__